import React, { Dispatch, SetStateAction } from "react";

interface RegistrationContextType {
  screen: string;
  setScreen: Dispatch<SetStateAction<string>>;
  authenticated: boolean;
  setAuthenticated: Dispatch<SetStateAction<boolean>>;
  registrationCode: string;
  setRegistrationCode: Dispatch<SetStateAction<string>>;
  error: string;
  setError: Dispatch<SetStateAction<string>>;
  status: string;
  setStatus: Dispatch<SetStateAction<string>>;
  reload: number;
  setReload: Dispatch<SetStateAction<number>>;
  reloadAdminBadges: number;
  setReloadAdminBadges: Dispatch<SetStateAction<number>>;
  loading: boolean;
  setLoading: Dispatch<SetStateAction<boolean>>;
  maxStep: string;
  setMaxStep: Dispatch<SetStateAction<string>>;
  data: Record<string, any>;
  setData: Dispatch<SetStateAction<Record<string, any>>>;
  cartOpen: boolean;
  setCartOpen: Dispatch<SetStateAction<boolean>>;
  cart: Record<string, any>;
  setCart: Dispatch<SetStateAction<Record<string, any>>>;
  cartAdded: boolean;
  setCartAdded: Dispatch<SetStateAction<boolean>>;
  userInfoOpen: boolean;
  setUserInfoOpen: Dispatch<SetStateAction<boolean>>;
  email: string;
  setEmail: Dispatch<SetStateAction<string>>;
  phase: string;
  setPhase: Dispatch<SetStateAction<string>>;
  inCommunication: boolean;
  setInCommunication: Dispatch<SetStateAction<boolean>>;
  paperOpen: boolean;
  setPaperOpen: Dispatch<SetStateAction<boolean>>;
  paperSelected: any[];
  setPaperSelected: Dispatch<SetStateAction<any[]>>;
  paperSelectedVerified: any[];
  setPaperSelectedVerified: Dispatch<SetStateAction<any[]>>;
  isAdmin: boolean;
  setIsAdmin: Dispatch<SetStateAction<boolean>>;
  adminRole: string;
  setAdminRole: Dispatch<SetStateAction<string>>;
  isImpersonating: boolean;
  setIsImpersonating: Dispatch<SetStateAction<boolean>>;
  isStudent: boolean;
  setIsStudent: Dispatch<SetStateAction<boolean>>;
  isMainAccess: boolean;
  setIsMainAccess: Dispatch<SetStateAction<boolean>>;
  optionAccess: string;
  setOptionAccess: Dispatch<SetStateAction<string>>;
  registrationType: string;
  setRegistrationType: Dispatch<SetStateAction<string>>;
  clickedNext: number;
  setClickedNext: Dispatch<SetStateAction<number>>;
  next: any;
  setNext: Dispatch<SetStateAction<any>>;
  prices: Record<string, any>;
  setPrices: Dispatch<SetStateAction<Record<string, any>>>;
  highlightedCart: boolean;
  setHighlightedCart: Dispatch<SetStateAction<boolean>>;
  upgradableOptions: any[];
  setUpgradableOptions: Dispatch<SetStateAction<any[]>>;
  isSoldout: boolean;
  setIsSoldout: Dispatch<SetStateAction<boolean>>;
  disclaimerAccepted: boolean;
  setDisclaimerAccepted: Dispatch<SetStateAction<boolean>>;
  workshops: any[];
  setWorkshops: Dispatch<SetStateAction<any[]>>;
  tutorials: any[];
  setTutorials: Dispatch<SetStateAction<any[]>>;
  papers: any[];
  setPapers: Dispatch<SetStateAction<any[]>>;
  permissions: string[];
  setPermissions: Dispatch<SetStateAction<string[]>>;
  ppiTier: string | null;
  setPpiTier: Dispatch<SetStateAction<string | null>>;
}

const defaultContext: RegistrationContextType = {
  screen: "loading",
  setScreen: () => {},
  authenticated: false,
  setAuthenticated: () => {},
  registrationCode: "",
  setRegistrationCode: () => {},
  error: "",
  setError: () => {},
  status: "",
  setStatus: () => {},
  reload: 0,
  setReload: () => {},
  reloadAdminBadges: 3,
  setReloadAdminBadges: () => {},
  loading: false,
  setLoading: () => {},
  maxStep: "",
  setMaxStep: () => {},
  data: {},
  setData: () => {},
  cartOpen: false,
  setCartOpen: () => {},
  cart: {},
  setCart: () => {},
  cartAdded: false,
  setCartAdded: () => {},
  userInfoOpen: false,
  setUserInfoOpen: () => {},
  email: "",
  setEmail: () => {},
  phase: "",
  setPhase: () => {},
  inCommunication: false,
  setInCommunication: () => {},
  paperOpen: false,
  setPaperOpen: () => {},
  paperSelected: [],
  setPaperSelected: () => {},
  paperSelectedVerified: [],
  setPaperSelectedVerified: () => {},
  isAdmin: false,
  setIsAdmin: () => {},
  adminRole: "",
  setAdminRole: () => {},
  isImpersonating: false,
  setIsImpersonating: () => {},
  isStudent: false,
  setIsStudent: () => {},
  isMainAccess: false,
  setIsMainAccess: () => {},
  optionAccess: "",
  setOptionAccess: () => {},
  registrationType: "",
  setRegistrationType: () => {},
  clickedNext: 0,
  setClickedNext: () => {},
  next: null,
  setNext: () => {},
  prices: {},
  setPrices: () => {},
  highlightedCart: false,
  setHighlightedCart: () => {},
  upgradableOptions: [],
  setUpgradableOptions: () => {},
  isSoldout: false,
  setIsSoldout: () => {},
  disclaimerAccepted: false,
  setDisclaimerAccepted: () => {},
  workshops: [],
  setWorkshops: () => {},
  tutorials: [],
  setTutorials: () => {},
  papers: [],
  setPapers: () => {},
  permissions: [],
  setPermissions: () => {},
  ppiTier: null,
  setPpiTier: () => {},
};

const RegistrationContext = React.createContext<RegistrationContextType>(defaultContext);

export default RegistrationContext;